<template>
  <v-list class="main__light_green flex wrap categories-list">
    <v-list-item
      v-for="(item, n) in categories"
      :key="n"
      class="pa-0 categories-list_item">
      <v-tooltip
        bottom
        content-class="tooltip black--text">
        <template #activator="{ on, attrs }">
          <v-chip
            class="chip-item h9-text-bold black--text px-2 py-3 mr-2 mt-2"
            :color="active(item) ? 'var(--color-main-green)' : disable(item) ? 'grey' : 'var(--black-color)'"
            dense
            :disabled="!!disable(item)"
            :outlined="!active(item)"
            @click="!disable(item) ? choose(item) : '' ">
            <span
              v-bind="attrs"
              class="chip-item-text"
              v-on="on"> {{ item[item_name || 'name'] }} </span>
            <sButton
              v-if="active(item)"
              icon="cross"
              icon-size="6px"
              small
              style="min-height: 6px; min-width: 6px; padding: 0;margin: 2px 0px 1px 3px"
              type="text"
              @click.stop="clearSelecting ? clearSelecting(item) : value = ''"/>
          </v-chip>
        </template>
        <span>  {{ disable(item) ? dis_text : item[item_name || 'name'] }} </span>
      </v-tooltip>
    </v-list-item>
  </v-list>
</template>
<script>

export default {
  name: 'categoriesList',
  props: {
    categories: Array,
    model: [Array, String, Number, Object],
    item_key: String,
    item_name: String,
    clearSelecting: Function ,
    selectChip: Function ,
    multiple: Boolean,
    used: [Array, String],
    multiple_condition: Boolean
  },
  computed: {
    value: {
      get() {
        return this.model
      },
      set(value) {
        this.$emit('update:model', value)
      }
    },
    dis_text() {
      return Array.isArray(this.used) ? this.$t('Tenders.SelectedInAdditionalCategory')
        : this.multiple_condition ? this.$t('Tenders.PossibleToAddAdittional') : this.$t('Tenders.SelectedCategory')
    }
  },
  methods: {
    choose(item) {
      if (this.active(item)) {
        if (this.clearSelecting) {
          this.clearSelecting(item)
        } else {
          this.value = ''
        }
        return
      }
      if (this.selectChip) {
        this.selectChip(item)
      } else {
        this.value = item[this.item_key] || item
      }
    },
    active(item) {
      let it = item[this.item_key] || (item.classificationCode || item.id),
        result = this.multiple ? this.value?.some(el => el[this.item_key] == (it[this.item_key] || it))
          : this.value ? it == ( this.value[this.item_key] || this.value ) : false
      return result
    },
    disable(item) {
      return Array.isArray(this.used) && this.used.find(el => el == item.classificationCode)
      || this.used == (item.classificationCode || item.id) || this.multiple_condition
    }
  }
}
</script>
<style lang="scss" scoped>
.chip-item {
  .chip-item-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 250px;
  }
  height: 20px !important;
}
.categories-list {
  // width: 400px;
  &_item {
    max-width: min-content;
    height: min-content;
    min-height: min-content;
  }
}
</style>
